/** Part evidence is not a payment receipt or a successful settlement. */
export function payinAuditLabel(action: unknown): string | undefined {
    switch (action) {
        case "payin_part_payment_failed": return "Отказ оплаты части";
        case "payin_part_confirmed": return "Поступление по части подтверждено";
        case "payin_part_replaced": return "Реквизит части заменён";
        default: return undefined;
    }
}
